import { render, staticRenderFns } from "./ProjBody.vue?vue&type=template&id=f0d2196c&"
import script from "./ProjBody.vue?vue&type=script&lang=js&"
export * from "./ProjBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports